<template>
  <section>
    <div class="container clearfix py-5 weps">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <h1 class="text-center">Platform Üyeleri</h1>
          <div class="row justify-content-center">
            <div class="clear"></div>
            <div class="col-md-11 my-5">
              <div class="row custom-clients">
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/agrilink.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/alisan.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/altunbilekler.png" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/anlatsin.png" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/aromsa.png" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/barrycallebaut.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/bicen.png" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/duran-dogan.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img
                    src="images/clients/ipsos.png"
                    style="width: 80px;"
                    alt="Clients"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/kalekimya.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/korozo.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img
                    src="images/clients/mnk.png"
                    style="width: 80px;"
                    alt="Clients"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img
                    src="images/clients/ogilvy.jpg"
                    style="width: 80px;"
                    alt="Clients"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/olmuksan.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/onur.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/sariyer.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img
                    src="images/clients/solvay.png"
                    style="width: 80px;"
                    alt="Clients"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/ucler.jpg" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/unite.png" alt="Clients" />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img
                    src="images/clients/unilever.png"
                    style="width: 80px;"
                    alt="Clients"
                  />
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <img src="images/clients/watsons.png" alt="Clients" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$root.$emit("loaded");
  }
};
</script>

<style></style>
